import logo from './Images/prime-logo.png';

const Footer = () => {
    return (
        <div className="container-fluid">
            <div className="row bg1 pt-5 pb-4">
                <div className="col-12 text-center" >
                <img src={logo} className='logo2' ></img>
                </div>
                <div className="col-12 text-center" >
                <a className='text-info fw-bold text-decoration-none pe-3'>Terms and Privacy Notice</a><a className='text-info fw-bold text-decoration-none pe-3'>Send us feedback</a><a className='text-info fw-bold text-decoration-none pe-3'>Help</a><a className='text-secondary fw-bold text-decoration-none pe-3'>© 1996-2023, Amazon.com, Inc. or its affiliates</a>
                </div>
            </div>

            
        </div>

    );
}
export default Footer;